<template>
    <div class="fileDetail">
        <el-button size="small" icon='el-icon-arrow-left' @click='backToList'>
            {{$translate('lang.E3202101260028', { defaultText: '返回' })}}
        </el-button>
        <h4>{{$translate('lang.E3202101260029', { defaultText: '档案详情' })}}</h4>
        <el-row class="detailContent">
            <el-col :span='12' v-for="(item,index) in columns" :key='index' class="itemColumn">
                <el-tooltip effect="dark" :content="item.label" placement="top" v-if='item.label.length > 15'>
                    <div class="label">{{item.label}}</div>
                </el-tooltip>
                <div class="label" v-else>{{item.label}}</div>
                <el-tooltip effect="dark" :content="item.value" placement="top" v-if='item.value.length > 30'>
                    <div class="value">{{item.value}}</div>
                </el-tooltip>
                <div class="value" v-else>{{item.value}}</div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    props: {
        detail: {
            type: Object,
            default: () => {
                return {};
            }
        },
        columns: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    methods: {
        backToList() {
            this.$emit('backToList');
        },
        getDetail(row) {
            // Object.keys(row).map(item => {
            //     this.columns.forEach(item2 => {
            //         if (item === item2.prop) {
            //             item2.value = row[item];
            //         }
            //     });
            //     return item;
            // });
            this.columns.forEach((item) => {
                item.value = row[item.prop] || '';
            });
        }
    }
};
</script>
<style lang="less">
.fileDetail {
    .detailContent {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        background: #f8f8f8;
        border-radius: 10px;
        margin-top: 15px;
        .itemColumn {
            display: flex;
            height: 50px;
            line-height: 50px;
        }
        .label {
            font-size: 14px;
            color: #888888;
            text-align: right;
            min-width: 98px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .value {
            box-sizing: border-box;
            font-size: 14px;
            color: #333333;
            padding: 1px 0 0 10px;
            display: inline-block;
            white-space: nowrap;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
        }
        .el-tooltip__popper.is-dark {
            max-width: 600px;
            background: #546371;
            color: #FFFFFF;
        }
        .el-tooltip__popper[x-placement^=top] .popper__arrow:after {
            border-top-color: #546371;
        }
    }
}
</style>
